export function initReveal() {
  const els = document.querySelectorAll('[data-reveal]')
  if (!els.length) return

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-visible')
      observer.unobserve(entry.target)
    })
  }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' })

  els.forEach(el => observer.observe(el))
}
